import {
	WeaTools
} from 'ecCom';

export const getSyncRight = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/getHasRight', 'GET', params);
}

export const getShowCol = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/getShowCol', 'GET', params);
}

export const saveColset = (params = {}) => {
	return WeaTools.callApi('/api/ec/dev/table/showCol', 'POST', params);
}

export const syncColset = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/syncShowCol2All', 'POST', params);
}

export const getSearchConditionOfLog = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/getSearchConditionOfLog', 'GET', params);
}

export const getHrmSearchLogList = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/getHrmSearchLogList', 'GET', params);
}

export const recordExport = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/exportExcelLog', 'POST', params);
}

export const getOrderBy4Search = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/getOrderBy4Search', 'GET', params);
}

export const saveOrderBy4Search = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/saveOrderBy4Search', 'POST', params);
}

export const syncOrderBy2All = (params = {}) => {
	return WeaTools.callApi('/api/hrm/search/syncOrderBy2All', 'POST', params);
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/addressbookPlus.js